// providers/eclipse.ts
import * as Api from '@ViewModels';
import { number, provider, select, toggle } from './helpers';

export const eclipseConfig = provider(Api.IntegrationProvider.Eclipse, {
	displayName: 'Eclipse',
	showConnections: false,

	configuration: {
		showSyncUser: false,
	},

	main: {
		writebacks: true,
		fields: [
			toggle('useSalutationAsFirstName', {
				label: 'Use Salutation as First Name',
				subtitle: 'Use the Eclipse salutation field as the contact first name instead of the actual first name',
			}),
			select(
				'commercialProfiles',
				[
					{ id: Api.CommercialProfiles.All, label: 'All' },
					{ id: Api.CommercialProfiles.PrimarySecondaryOnly, label: 'Primary & Secondary Only' },
					{ id: Api.CommercialProfiles.PrimaryOnly, label: 'Primary Only' },
				],
				{
					label: 'Commercial Profiles',
					subtitle: 'Controls which commercial profiles are synced from Eclipse',
				}
			),
			select(
				'personalProfiles',
				[
					{ id: Api.PersonalProfiles.PrimarySecondaryOnly, label: 'Primary & Secondary Only' },
					{ id: Api.PersonalProfiles.PrimaryOnly, label: 'Primary Only' },
				],
				{
					label: 'Personal Profiles',
					subtitle: 'Controls which personal profiles are synced from Eclipse',
				}
			),
			select(
				'prospectIntegration',
				[
					{ id: Api.ProspectIntegration.None, label: 'None' },
					{ id: Api.ProspectIntegration.All, label: 'All' },
					{ id: Api.ProspectIntegration.Timeline, label: 'Timeline' },
				],
				{
					label: 'Prospect Sync',
					subtitle: 'Controls whether prospect contacts are synced from Eclipse',
					parentKey: 'prospectOptions',
				}
			),
			number('timelineYears', {
				label: 'Timeline Years',
				subtitle: 'Number of years of prospect history to sync',
				min: 1,
				max: 10,
				placeholder: 'Years',
				displaySuffix: 'year',
				parentKey: 'prospectOptions',
				visibleWhen: {
					key: 'prospectIntegration',
					parentKey: 'prospectOptions',
					value: Api.ProspectIntegration.Timeline,
				},
				isSubSetting: true,
			}),
		],
	},

	keyFacts: {
		birthdayDisplay: true,
	},

	tags: {
		coreTags: true,
		providerTags: [{ id: 'Carrier', label: 'Carrier', settingsKey: 'carrierEnabled' }],
		extraFields: [
			toggle('displayBothOwnershipRoleTags', {
				label: 'Display Both Ownership Role Tags',
				subtitle: 'Add both CSR and Producer tags instead of just the selected ownership role',
			}),
		],
	},
});
